
import Vue from "vue";
import action from "@/components/ActionBarCom.vue";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import Utils from "@/assets/js/Utils";
import dialogCom from "@/components/ModelCom.vue";
import delCom from "@/components/DelDataCom.vue";
export default Vue.extend({
  components: { action, dialogCom, delCom },
  data() {
    return {
      delUrl: Urls.DelUsers,
      currentSid: "",
      items: [] as any[],
      total: 0,
      pageSize: 50,
      currentPage: 0,
      searchStr: null as any,
      dialogTitle: {
        title: "报警配置",
      },
      projectForm: {} as any,
      current: null as any,
      projects: [] as any[],
    };
  },
  async mounted() {
    await this.getProjects();
    await this.select();
    await this.getAlarmSet();
  },
  methods: {
    async getProjects() {
      const dfata: any = {
        page: 1,
        pageSize: 1000,
        pagination: true,
      };
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetProjects, dfata, true, false);
      this.projects = ret.data;
    },
    async getAlarmSet() {
      this.projectForm = await HttpUtil.XCHttpPost(Urls.GetProjectAlarm, "", true, false);
      console.log(this.projectForm);
    },
    async select() {
      if (this.currentPage == 0) {
        this.items = [];
      }
      const obj = {
        count: this.pageSize,
        skip: this.currentPage * this.pageSize,
      };
      const ret: any[] = await HttpUtil.XCHttpPost(
        Urls.GetProjectAlarms,
        obj,
        true,
        false
      );
      ret.forEach((x: any) => {
        this.items.push(x);
      });
    },
    currentChange(val: any) {
      this.current = val;
    },
    insert() {
      this.current = null;
      this.projectForm = {
        sid: null,
      };
      this.dialogTitle.title = "新增用户";
      const dialog: any = this.$refs.projectDialog;
      dialog.show();
    },
    closeDialog() {
      const dialog: any = this.$refs.projectDialog;
      dialog.hiden();
    },
    modify() {
      const dialog: any = this.$refs.projectDialog;
      dialog.show();
    },
    del() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.currentSid = this.current.sid;
      const dialog: any = this.$refs.del;
      dialog.show();
    },
    ex() {
      //
    },
    inport() {
      //
    },
    search() {
      this.select();
    },
    searchChanged(str: string) {
      this.searchStr = str;
    },
    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.select();
    },
    conClick(str: string) {
      alert(str);
    },
    more() {
      this.currentPage += 1;
      this.select();
    },
    async onSubmit() {
      await HttpUtil.XCHttpPost(Urls.SetProjectAlarm, this.projectForm, true, false);
      this.closeDialog();
      this.getAlarmSet();
    },
  },
});
